
export function mapSnapshot(sh, sortField = "id"){


    let object = {};

    if(sh.forEach){
        sh.forEach(doc => {
            mapSingleItem(doc, sortField, object);
        })
    }else{
        if(sh.data) { // object already fetched
            if(sh.exists) {
                mapSingleItem(sh, sortField, object);
            }
        }else if(sh.get){ // object needs to be fetched
            return sh.get().then(res => mapSnapshot(res))
        }else{ // normal object
            return {[sh.id] : sh};
        }
    }

    return object;
}
const mapSingleItem = (item, sortField, object) => {
    const data = item.data();
    const key = (sortField === "id") ? item.id : data[sortField];
    object[key] = data;
    object[key].id = item.id;
}

export function cleanUndefined(params){
    for (var propName in params) {
        if (params[propName] === undefined) {
            delete params[propName];
        }
    }
}

export function addDates(params){
    const date = new Date();

    params.updatedAt = date;
    if(!params.id) params.createdAt = date;
}


// WEBPACK FOOTER //
// ./src/api.js